export enum Stage {
	IN_PROGRESS = 'IN_PROGRESS',
	AWAITING_PHOTOS = 'AWAITING_PHOTOS',
	AI_DECISION_AVAILABLE = 'AI_DECISION_AVAILABLE',
	LINK_EXPIRED = 'LINK_EXPIRED',
	ACCEPTED_OFFER = 'ACCEPTED_OFFER',
	DECLINED_OFFER = 'DECLINED_OFFER',
}
